/*
 * What a scaled vignette stage is to the stylesheet. VignetteFrame marks the
 * box it lays its content out in with STAGE_ATTRIBUTE, and the build's PostCSS
 * step (resources/css/vignetteStage.js) rewrites every viewport-size media
 * query so that, inside a marked box, it is answered for STAGE_VIEWPORT
 * instead of the visitor's screen. A stage on a phone therefore draws the
 * app's desktop variants (`sm:`, `lg:`, `max-md:`, `min-[480px]:`, ...), the
 * same ones a 1440 x 900 window draws, only smaller.
 *
 * Plain data, no imports: the PostCSS step reads it from Node. Vite reads the
 * PostCSS config once: after editing this file, restart the dev server.
 */

/** The attribute VignetteFrame puts on the box a scaled vignette is laid out in. */
export const STAGE_ATTRIBUTE = 'data-vignette-stage';

/** The window every stage's media queries are answered for (CSS px). */
export const STAGE_VIEWPORT = Object.freeze({ width: 1440, height: 900 });

/**
 * The scales a phone's crop of a hero's stage draws at (R-5, R1-5), by
 * hero: readable, where fitting the stage to a phone would draw it at about
 * a quarter. Home's 1200px window at 0.6 (its rows, its drawer and its rail
 * each fit a 390px phone's view, 577 layout px), Platform's 1320px stage at
 * 0.5 (its source cards and the rows their values land in fit together).
 * Below 640px a hero gives its vignette a box this share of its stage's
 * width (a camera, `data-vignette-camera`), so VignetteFrame fits the stage
 * to it at this scale, whole in height and in its desktop layout; the
 * bezel's plate shows the part of it as wide as itself, and the story's
 * cues pan the camera (glide.js useCropCamera). From 640px the box is kept,
 * style-neutral, and the stage is fitted as before.
 */
export const CROP_SCALES = Object.freeze({ home: 0.6, platform: 0.5 });

/**
 * The floor of a crop's scale (R-5: at least about 0.5), and the view
 * (layout px) Home's crop targets need with their margins: its safety
 * row's name and value (to about 541) and its drawer's editor (about 495).
 * Home's box takes CROP_SCALES.home where that view fits it (375px phones
 * and up) and shrinks toward the floor below that, so a 320px phone still
 * shows each target whole.
 */
export const CROP_FLOOR = 0.5;
export const HOME_CROP_VIEW = 552;
